export default {
  free_menu_items: 'Free unlocked',
  discount_badge: '{{value}} off',
};
